import React from 'react';

const About: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-4xl font-bold">Updated About Page</h1>
    </div>
  );
};

export default About;
